import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  // Restore scroll on route change — honor hash anchors when present
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // Two passes: an early smooth scroll, then a corrective jump once
        // above-the-fold images/sections have finished loading and layout settles.
        const t1 = setTimeout(() => {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
          else el.scrollIntoView({ block: "start" });
        }, 150);
        const t2 = setTimeout(() => {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, immediate: true });
          else el.scrollIntoView({ block: "start" });
        }, 1100);
        return () => { clearTimeout(t1); clearTimeout(t2); };
      }
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return children;
}
